import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'


export const getDriverDetail = createAsyncThunk('DriverStatusDashboard/getDriverDetail', async (GetDriver) => {
    
      const response = await axios.post('https://api.zasway.com:8443/Driver/GetTableSummaryDriver', GetDriver, { mode: 'cors' })
    
      return response.data
})
export const GetDocumentDetailsByOwnerType = createAsyncThunk('appDriver/GetDocumentDetailsByOwner', async (Owner) => {

    const response = await axios.post('https://api.zasway.com:8443/Common/GetDocumentSummaryByOwnerType', Owner, { mode: 'cors' })
    return response.data
  })
  export const AddRideLocationLog = createAsyncThunk('UpcomingBooking/AddRideLocationLog ', async (params) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Booking/AddLiveLocationLog', params, { mode: 'cors' })
       
    return response.data
  })
  export const CheckLocation = createAsyncThunk('UpcomingBooking/CheckLocation', async (params) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingLiveLocationList', params, {mode:'cors'})
   
    return response.data
  })
 export const updateDriverStatus = createAsyncThunk('updatedriver/updatePersonalProfile ', async (params) => {
        
        const response = await axios.post('https://api.zasway.com:8443/Driver/UpdateDriverStatus', params, { mode: 'cors' })
          
        return response.data
 })
 export const AddDriverShift = createAsyncThunk('updatedriver/updatePersonalProfile ', async (params) => {
        
    const response = await axios.post('https://api.zasway.com:8443/Driver/AddDriverShift', params, { mode: 'cors' })
      
    return response.data
})
export const updateBookingStatusOnRoute = createAsyncThunk('updatedriver/updateBookingStatusOnRoute ', async (params) => {
        
    const response = await axios.post('https://api.zasway.com:8443/Driver/UpdateBookingStatusForJourney', params, { mode: 'cors' })
      
    return response.data
})

export const setStatus = createAsyncThunk('DriverStatusDashboard/setStatus', async (status) => {   
     
    return status
})
export const DriverStatusDashboardSlice = createSlice({
    name: 'DriverStatusDashboard',
    initialState: {
        data: [],
        userStatus: 3
    },
    reducers: {},
    extraReducers: builder => {
        builder
           
            .addCase(getDriverDetail.fulfilled, (state, action) => {
                 
                state.data = action.payload.data
            })
            .addCase(setStatus.fulfilled, (state, action) => {
                
                state.userStatus = action.payload.status
            })

    }
})
export default DriverStatusDashboardSlice.reducer